import { IGenericObject } from '../tests';
import { IFormationPlayer, transformFormationPlayer } from './formation-players';

export type Orientation = 'vertical' | 'horizontal';

export interface IMatchFormationField {
  readonly debug?: boolean;
  readonly formation: IGenericObject | '';
  readonly players: ReadonlyArray<IFormationPlayer>;
  readonly customFormationSchema?: readonly IGenericObject[];
  readonly hasImage?: boolean;
  readonly orientation?: Orientation;
}

const getFormationRoles = (teamLineup: IGenericObject): ReadonlyArray<IFormationPlayer> | undefined =>
  teamLineup?.playerList?.startingLineup?.map((player: IGenericObject) => {
    return transformFormationPlayer(player, teamLineup.formation);
  });

export const transformFormationFields = (matchLineups: IGenericObject): IGenericObject => {
  const homeLineup: IGenericObject = matchLineups?.home;
  const awayLineup: IGenericObject = matchLineups?.away;

  if (homeLineup && awayLineup) {
    const homeFormation: IMatchFormationField = {
      formation: homeLineup.formation,
      players: getFormationRoles(homeLineup) || [],
      hasImage: false,
    };
    const awayFormation: IMatchFormationField = {
      formation: awayLineup.formation,
      players: getFormationRoles(awayLineup) || [],
      hasImage: false,
    };

    const transformedFormationsLineups = {
      home: homeFormation,
      away: awayFormation,
    };

    return transformedFormationsLineups;
  }

  return {
    home: {},
    away: {},
  };
};
